export const MONTHLY_COINS = 4;
export const COIN_VALUE_IN_RUPEES = 500;
